export default __webpack_public_path__ + "static/media/search.730fc87f.svg";